import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";
import BasicSelect from "./fields/BasicSelect";
import CustomDatePicker from "./fields/CustomDatePicker";
import moment from "moment";
import { baseValue } from "../../libs/utils";
import WYSIWYG from "./fields/WYSIWYG";
import CustomTimePicker from "./fields/CustomTimePicker";
import BasicCheckbox from "./fields/BasicCheckbox";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setValues: PropTypes.func,
    setFieldValue: PropTypes.func,
    venue: PropTypes.object,
    event: PropTypes.object,
    isCreating: PropTypes.bool,
    events: PropTypes.array,
    venues: PropTypes.array,
    values: PropTypes.object
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { event } = nextProps;
    const currentProps = this.props;

    if (event && currentProps.event !== event) {
      currentProps.setValues({
        name: baseValue(event.name),
        id: baseValue(event.id, undefined),
        day_start_hour: baseValue(
          event.dayStartTime
            ? moment
                .utc(moment().format("YYYY-MM-DD") + " " + event.dayStartTime)
                .utcOffset(120)
            : moment.utc("2018-05-20 04:00:00").utcOffset(120)
        ),
        previous_event: baseValue(event.previousEventId),
        venue: baseValue(event.venueId),
        crew_member_welcome_html: baseValue(event.crewMemberWelcomeHtml),
        crew_admin_welcome_html: baseValue(event.crewAdminWelcomeHtml),
        registration_start: event.registrationStartsAt
          ? moment(event.registrationStartsAt)
          : moment(),
        registration_end: event.registrationEndsAt
          ? moment(event.registrationEndsAt)
          : undefined,
        reminder_start: event.registrationReminderStartsAt
          ? moment(event.registrationReminderStartsAt)
          : moment(),
        reminder_end: event.registrationReminderEndsAt
          ? moment(event.registrationReminderEndsAt)
          : undefined,
        bornBefore: event.bornBefore
          ? moment(event.bornBefore)
          : moment().subtract(18, "year"),
        redirect: false
      });
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      currentProps.resetForm();
    }
  }

  render() {
    const props = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />
          <div className="form-group m-form__group row">
            <div className="col-lg-6">
              <BasicInput {...props} name="name" type="text" label="Name" />
            </div>
            <div className="col-lg-6">
              <label style={{ height: 0 }}>&nbsp;</label>
              <BasicCheckbox
                {...props}
                name="reporting_active"
                label="Active Event (Reporting)"
              />
            </div>
          </div>

          <div className="form-group m-form__group row">
            <div className="col-lg-6">
              <CustomTimePicker
                {...props}
                name="day_start_hour"
                type="time"
                label="Start of Day"
                noFormGroup
                showSecond={false}
                minuteStep={10}
              />
            </div>
            <div className="col-lg-6">
              <CustomDatePicker
                {...props}
                name="bornBefore"
                label="Born before"
                showMonthDropdown
                showYearDropdown
              />
            </div>
          </div>

          <BasicSelect
            {...props}
            name="previous_event"
            options={this.props.events.map(event => {
              return { value: event.id, title: event.name };
            })}
            label="Previous Year"
            none="-- No Previous Edition --"
          />

          <BasicSelect
            {...props}
            name="venue"
            options={this.props.venues.map(venue => {
              return { value: venue.id, title: venue.name };
            })}
            label="Venue"
            placeholder="Choose a venue"
          />
          <div className="form-group m-form__group row">
            <div className="col-lg-6">
              <CustomDatePicker
                {...props}
                name="registration_start"
                label="Registration Start"
              />
            </div>
            <div className="col-lg-6">
              <CustomDatePicker
                {...props}
                name="registration_end"
                label="Registration End"
                minDate={moment(this.props.values["registration_start"])}
                showMonthDropdown
              />
            </div>
          </div>
          <div className="form-group m-form__group row">
            <div className="col-lg-6">
              <CustomDatePicker
                {...props}
                name="reminder_start"
                label="Reminder Start"
              />
            </div>
            <div className="col-lg-6">
              <CustomDatePicker
                {...props}
                name="reminder_end"
                label="Reminder End"
                minDate={moment(this.props.values["reminder_start"])}
                showMonthDropdown
              />
            </div>
          </div>
          <WYSIWYG
            {...props}
            name="crew_member_welcome_html"
            label="Crew Frontend Text"
          />
          <WYSIWYG
            {...props}
            name="crew_admin_welcome_html"
            label="Admin Frontend Text"
          />
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              {!props.event && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                  onClick={() => this.props.setFieldValue("redirect", true)}
                >
                  Create & Add Periods
                </button>,

                <button
                  key="3"
                  className={
                    "m--margin-left-10 btn m-btn btn-secondary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                  onClick={() => this.props.setFieldValue("redirect", false)}
                >
                  {props.event ? "Update" : "Create"}
                </button>
              ]}

              {props.event && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                >
                  Update
                </button>,

                <span key="2" className="m--margin-left-10">
                  or{" "}
                  <Link to="/admin/events" className="m-link m--font-bold">
                    Cancel
                  </Link>
                </span>
              ]}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const VenueForm = withFormik({
  mapPropsToValues: props => {
    const event = baseValue(props.event, {});

    let values = {
      name: baseValue(event.name),
      id: baseValue(event.id, undefined),
      day_start_hour: baseValue(
        event.dayStartTime
          ? moment
              .utc(moment().format("YYYY-MM-DD") + " " + event.dayStartTime)
              .utcOffset(120)
          : moment.utc("2018-05-20 04:00:00").utcOffset(120)
      ),
      previous_event: baseValue(event.previousEventId),
      venue: baseValue(event.venueId),
      reporting_active: baseValue(event.reportingActive),
      crew_member_welcome_html: baseValue(event.crewMemberWelcomeHtml),
      crew_admin_welcome_html: baseValue(event.crewAdminWelcomeHtml),
      registration_start: event.registrationStartsAt
        ? moment(event.registrationStartsAt)
        : moment(),
      registration_end: event.registrationEndsAt
        ? moment(event.registrationEndsAt)
        : undefined,
      reminder_start: event.registrationReminderStartsAt
        ? moment(event.registrationReminderStartsAt)
        : moment(),
      reminder_end: event.registrationReminderEndsAt
        ? moment(event.registrationReminderEndsAt)
        : undefined,
      bornBefore: event.bornBefore
        ? moment(event.bornBefore)
        : moment().subtract(18, "year"),
      redirect: false
    };

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    if (!values.venue || values.venue === "") {
      errors.venue = "required";
    }

    if (!values.day_start_hour || values.day_start_hour === "") {
      errors.day_start_hour = "required";
    }

    if (!values.registration_start || values.registration_start === "") {
      errors.registration_start = "required";
    }

    if (!values.registration_end || values.registration_end === "") {
      errors.registration_end = "required";
    }

    if (!values.reminder_start || values.reminder_start === "") {
      errors.reminder_start = "required";
    }

    if (!values.bornBefore || values.bornBefore === "") {
      errors.bornBefore = "required";
    }

    if (!values.reminder_end || values.reminder_end === "") {
      errors.reminder_end = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default VenueForm;
